import script from "./DiseasePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiseasePopup.vue?vue&type=script&setup=true&lang=ts"

import "./DiseasePopup.vue?vue&type=style&index=0&id=49ec4817&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ec4817"]])

export default __exports__